// extracted by mini-css-extract-plugin
module.exports = {"table":"ReceipeTable_table__pqWg3"};